module.exports = "/_next/static/images/software-development-banner-46a295830f77d7f351295e8539205e70.webp";